module.exports = __webpack_public_path__ + "static/media/network.ac5eac8f.svg";